document.addEventListener("DOMContentLoaded", function() {
    const aboutHistoryItem = document.querySelector('.section-about-history-block__item');
    const sectionIntro = document.querySelector('.section-about-history-block__intro');

    if (aboutHistoryItem && sectionIntro) {
        const isMobile = window.innerWidth <= 768;

        if (isMobile) {
            sectionIntro.insertAdjacentElement('afterend', aboutHistoryItem);
        }
    }
});
